/**
 * Non letti WhatsApp per i badge globali (menu e icona Messaggi), senza le chat
 * silenziate. Le preferenze arrivano da whatsappChatMetaStore (caricate con la lista chat).
 */
import { useMemo } from 'react';
import { useWhatsAppChatStore } from '@/lib/stores/whatsappChatStore';
import { useWhatsAppChatMetaStore } from '@/lib/stores/whatsappChatMetaStore';
import { unreadTotalExcludingMuted } from '@/lib/services/whatsapp/chatListRules';

export function useWhatsAppUnreadTotal(): number {
  const chats = useWhatsAppChatStore((s) => s.chats);
  const chatMeta = useWhatsAppChatMetaStore((s) => s.chatMeta);
  return useMemo(() => unreadTotalExcludingMuted(chats, (id) => chatMeta.get(id)), [chats, chatMeta]);
}
